import { makeStyles, shorthands } from '@fluentui/react-components';
import CircleSolid from '../media/CircleSolid.svg';
import CircleDotted from '../media/CircleDotted.svg';
import DiamondSolid from '../media/DiamondSolid.svg';
import DiamondDotted from '../media/DiamondDotted.svg';
import Waterdrop from '../media/Waterdrop.svg';

export const useInlineChartContainerStyle = makeStyles({
  inlineChartContainer: {
    flexShrink: '0',
    zIndex: '400',
    boxShadow: 'inset 0px 0.6px 1.8px rgba(0, 0, 0, 0.108), inset 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    '& .top-grid-form': {
      minWidth: 'initial',
      maxWidth: 'initial',
    },
    '& .chart-area-wrapper': {
      display: 'flex',

      '& .react-block-ui-none, .react-block-ui': {
        flexGrow: '1',
      },

      '& .inline-chart-container': {
        flexGrow: '1',
        paddingTop: '16px',
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingBottom: '22px',
        display: 'flex',
        flexDirection: 'column',
        width: 'auto !important',
        '& .highcharts-label-box.highcharts-tooltip-box': {
          opacity: '0 !important',
        },
        '& .tool-tip-value': {
          fontSize: '16px',
          paddingLeft: '20px',
          paddingTop: '2px',
        },
        '& .primary-daterange': {
          color: '#323130',
          fontSize: '11px',
          fallbacks: [
            {
              color: '#323130',
            },
          ],
        },
        '& .primary-start-date, & .comparison-start-date': {
          paddingLeft: '20px',
          display: 'inline-block',
          fallbacks: [
            {
              paddingLeft: '20px',
            },
          ],
        },
        '& .primary-end-date, & .comparison-end-date': {
          position: 'absolute',
          display: 'inline-block',
          right: '0',
          fallbacks: [
            {
              right: '0',
            },
            {
              position: 'absolute',
            },
          ],
        },
        '& .comparison-daterange': {
          color: '#605e5c',
          fontSize: '11px',
          fallbacks: [
            {
              color: '#605E5C',
            },
          ],
        },
        '& .flex-chart-panel': {
          display: 'flex',
          paddingBottom: '16px',
          alignSelf: 'flex-end',
        },
        '& .chart-panel-left': {
          alignItems: 'flex-start',
          lineHeight: '19px',
          paddingTop: '6px',
          height: '38px',
        },
        '& .chart-panel-right': {
          display: 'flex',
          ...shorthands.flex(1, 1, 'auto'),
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          '& .glyphicon-triangle-bottom': {
            fontSize: '12px',
            marginLeft: '5px',
            fontFamily: 'MsAds MDL2 Assets !important',
            float: 'right',
            marginRight: '0',
            height: '12px !important',
            width: '12px !important',
          },
          '& .glyphicon-triangle-bottom:before': {
            content: '"\\E70D" !important',
          },
        },
        '& .metrics-pickers': {
          display: 'flex',

          '& .metric-colors': {
            display: 'flex',
          },
          '& .metrics-vs': {
            ...shorthands.margin('0px', '16px'),
            paddingLeft: '0px',
            paddingRight: '0px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
          '& .metric-color-line': {
            width: '12px',
            height: '42px',
            backgroundRepeat: 'no-repeat',
          },
          '& .show-comparison-line': {
            display: 'inline-block',
          },
          '& .hide-comparison-line': {
            display: 'none',
          },
          '& .comparison-color': {
            marginLeft: '4px',
          },
          '& .primary-metric .metric-color': {
            backgroundImage: `url("${CircleSolid}")`,
          },
          '& .primary-metric .comparison-color': {
            backgroundImage: `url("${CircleDotted}")`,
          },
          '& .secondary-metric .metric-color': {
            backgroundImage: `url("${DiamondSolid}")`,
          },
          '& .secondary-metric .comparison-color': {
            backgroundImage: `url("${DiamondDotted}")`,
          },
          '& .list-selector-container': {
            maxHeight: '400px',
            ...shorthands.overflow('auto'),
            '& .selected': {
              ...shorthands.outline('1px', 'auto', '#000000'),
            },
          },
        },
        '& .granularity-picker, & .primary-metric, & .secondary-metric': {
          display: 'flex',
          alignItems: 'center',
          alignSelf: 'center',
          height: '100%',
          '& .btn': {
            fontSize: '14px',
          },
          '& .btn-default': {
            fontWeight: 'normal',
          },
          '& .dropdown-menu': {
            top: 'auto',
            position: 'absolute',
            minWidth: '110px',
            whiteSpace: 'nowrap',

            '& .container': {
              ...shorthands.padding('0'),
            },
          },
          '& .dropdown-toggle.btn': {
            ...shorthands.border('none'),
            ...shorthands.borderRadius('2px'),
            width: '100%',
            height: '100%',
            paddingLeft: '8px',
            paddingRight: '8px',
          },

          '& .ba-dropdown-selector': {
            position: 'relative',
            ...shorthands.border('1px', 'solid', '#605e5c'),
            minWidth: '132px',
            verticalAlign: 'baseline',
            marginLeft: '8px',
            height: '30px',
            ...shorthands.borderRadius('2px'),
            '& > button': {
              display: 'flex',
              alignItems: 'center',
            },
          },

          '& .selectedItem-data': {
            display: 'inline-block',
            marginRight: '5px',
          },

          '& .comparison-container': {
            display: 'inline-block',
          },

          '& .show-selectedItem-percentage': {
            paddingLeft: '5px',
            display: 'inline-block',
          },

          '& .hide-selectedItem-percentage': {
            ...shorthands.padding('0px'),
            ...shorthands.margin('0px'),
            display: 'none',
          },

          '& .ba-list-selector': {
            ...shorthands.border('none'),
            '& .empty-message': {
              position: 'absolute',
              ...shorthands.padding('5px', '10px'),
            },
            '& .list-selector-item': {
              ...shorthands.padding('5px', '10px'),
              ...shorthands.margin('0px'),
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: '#f5f5f5',
              },
              '&.selected': {
                backgroundColor: '#E7F0F6',
              },
              '& .item-actions': {
                float: 'right',
              },
              '& .inline-recommendation-grid-icon:before': {
                fontFamily: 'MsAds MDL2 Assets',
                content: '"\\EA80"',
                display: 'inline-block',
                fontWeight: 'normal',
                fontStyle: 'normal',
                ...shorthands.textDecoration('ingerit'),
                speak: 'none',
                fontVariant: 'normal',
                textTransform: 'none',
                lineHeight: '1',
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
                fontSize: '14px',
                verticalAlign: 'middle',
                color: '#0078D4',
                paddingBottom: '2px',
              },
              '& .inline-recommendation-grid-icon:hover': {
                cursor: 'pointer',
              },
              '& .inline-chart-option': {
                marginLeft: '5px',
              },
            },
          },
        },

        '& .granularity-picker, & .secondary-metric': {
          '& .dropdown-menu': {
            left: 'auto',
            right: '0',
          },
        },

        '& .moving-average': {
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          fontStyle: 'normal',
          fontSize: '14px',
          fontWeight: 'normal',
          marginLeft: '16px',
          whiteSpace: 'nowrap',
          '& input[type=checkbox]': {
            height: '20px',
            width: '20px',
          },
          '& label': {
            display: 'inline-block',
            fontWeight: 'normal',
            '& input': {
              ...shorthands.margin('0px', '5px'),
              lineHeight: 'normal',
              verticalAlign: 'middle',
            },
          },
        },
        '& .react-highchart-wrapper': {
          '& > div[role="region"]': {
            ...shorthands.overflow('visible !important'),
          },
        },
        '& .highcharts-container': {
          ...shorthands.overflow('visible !important'),
          '& .highcharts-root': {
            ...shorthands.overflow('visible !important'),
          },
        },
        '& .chart-container': {
          ...shorthands.padding('0px'),
          position: 'relative',
        },

        '& .balloon, & .balloonYellow, & .balloonUnknown': {
          position: 'absolute',
          top: '-20px',
        },
        '& .balloon, & .balloonYellow, & .balloonUnknown:hover': {
          cursor: 'pointer',
        },

        '& .fluc-image': {
          backgroundImage: `url("${Waterdrop}")`,
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'left',
          backgroundPositionY: 'center',
          width: '28px',
          height: '38px',
          textAlign: 'center',
          paddingLeft: '1px !important',
          paddingTop: '11px !important',

          '&:before': {
            fontFamily: 'MsAds MDL2 Assets',
            content: '"\\EA80"',
            color: 'white',
            fontSize: '16px',
          },
        },

        '& .fluc-lightbulb': {
          '&:before': {
            fontFamily: 'MsAds MDL2 Assets',
            content: '"\\EA80"',
            color: '#0078D4',
            fontSize: '16px',
          },
        },

        '& .chart-no-data-container': {
          textAlign: 'center',
          ...shorthands.borderLeft('0 !important'),
          ...shorthands.borderRight('0 !important'),
          height: '120px',
          lineHeight: 'initial',
          paddingTop: '22px',
          paddingBottom: '60px',
          ...shorthands.border('solid', '1px', '#e1dfdd'),
          marginRight: '0px',
          marginTop: '19px',
          '& .chart-no-data-label': {
            marginLeft: '0',
            ...shorthands.borderBottom('solid', '1px', '#e1dfdd'),
            display: 'inline-block',
            height: '100%',
            width: '100%',
          },
        },
        '& .spinner': {
          paddingTop: '50px',
          paddingBottom: '59px',
          '& .spinner-icon': {
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        },
        '& .highcharts-label.highcharts-tooltip': {
          ...shorthands.margin('0px !important'),
          width: 'auto !important',
          minWidth: '150px !important',
          height: 'auto !important',
          minHeight: '100px !important',
          '& > span:nth-of-type(1)': {
            fontFamily: 'Segoe UI !important',
            ...shorthands.border('none'),
          },
        },
        '& .perf-graph-tool-tip': {
          display: 'flex',
          boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          ...shorthands.padding('11px', '15px'),
          '@supports (backdrop-filter: blur(60px))': {
            backdropFilter: 'blur(60px)',
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
          },
          '& .charts-tooltip': {
            color: '#323130',
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            display: 'inline-block',

            '& .primary, & .primary-comparison, & .movingaverage, & .movingaverage-comparison': {
              backgroundRepeat: 'no-repeat',
              backgroundSize: '12px 40px',
              height: '40px',
              '& .toolTipMetric': {
                height: '12px',
                marginRight: '8px',
                marginTop: '8px',
                paddingLeft: '20px',
              },
            },
            '& b': {
              fontWeight: 'normal',
            },
            '& .primary': {
              backgroundImage: `url("${CircleSolid}")`,
            },
            '& .primary-comparison': {
              backgroundImage: `url("${DiamondSolid}")`,
            },
            '& .movingaverage': {
              backgroundImage: `url("${CircleDotted}")`,
            },
            '& .movingaverage-comparison': {
              backgroundImage: `url("${DiamondDotted}")`,
            },
          },
          '& .charts-tooltip:nth-of-type(2)': {
            marginLeft: '16px !important',
          },
        },
      },
    },
    '& .bingads-popover': {
      zIndex: '100',
    },
  },
});
